import * as React from "react";

import { gtmEvent } from "src/library/utils/tagmanager-events";
import {
  GTMEventName,
  GTMEventType
} from "src/library/utils/tagmanager-events/gtm-types";
import useCurrentUser from "src/core/users/hooks/useCurrentUser";

export const useGTMEvent = (): typeof gtmEventWithUser => {
  const [ { currentUser, currentRole } ] = useCurrentUser();

  const gtmEventWithUser = React.useCallback(<D extends GTMEventName, CustomParams = unknown>(eventName: D, eventParams: GTMEventType<D, CustomParams>): void => {
    gtmEvent(eventName, eventParams, currentRole && currentUser ? {
      user_id: currentUser.id.toString(),
      user_role: currentRole?.code,
      user_type: currentRole?.type
    } : undefined);
  }, [ currentUser, currentRole ]);

  return gtmEventWithUser;
};
